import { Share2, Copy, HeartHandshake } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { brl } from "@/lib/format";

export default function ShareCard({ meta, config, nome, valor }) {
  const igreja = config?.nome_igreja || "Igreja Unida Deus Proverá";
  const url = window.location.origin;
  const primeiro = (nome || "").trim().split(" ")[0];
  const restante = Math.max(meta.valor_restante - (valor || 0), 0);
  const texto =
    `🙏 Acabei de ajudar a pagar *${meta.referente}* da ${igreja}!\n` +
    (restante > 0 ? `Ainda faltam ${brl(restante)} para concluir esta meta.\n` : `Com essa ajuda a meta ficou bem perto de ser concluída!\n`) +
    `Você também pode ajudar, é rápido e simples:\n${url}`;

  const shareWhatsapp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, "_blank", "noopener,noreferrer");
  };

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(texto);
      toast.success("Convite copiado! Cole onde quiser compartilhar.");
    } catch (e) {
      toast.error("Não foi possível copiar.");
    }
  };

  const nativo = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: igreja, text: texto }); } catch (e) {}
    } else {
      copiar();
    }
  };

  return (
    <div data-testid="share-card" className="relative overflow-hidden rounded-2xl bg-[#0f2a6b] text-white p-5 sm:p-6 shadow-[0_18px_40px_-18px_rgba(15,42,107,0.8)]">
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-sky-400/25 blur-3xl pointer-events-none" aria-hidden />
      <div className="absolute inset-0 hero-grain pointer-events-none" aria-hidden />
      <div className="relative">
        <div className="flex items-center gap-3">
          <img src="/brand/logo.jpg" alt={igreja} data-testid="share-card-logo" className="h-12 w-auto rounded-lg ring-1 ring-white/20 shadow-lg object-cover" />
          <div className="text-blue-200 text-xs font-bold tracking-[0.14em] uppercase leading-snug">{igreja}</div>
        </div>
        <p className="font-heading mt-3 text-2xl sm:text-3xl font-extrabold leading-tight">
          {primeiro ? `${primeiro}, obrigado` : "Obrigado"} por abençoar esta obra!
        </p>
        <p className="mt-2 text-sm sm:text-base text-blue-100/90 inline-flex items-start gap-2">
          <HeartHandshake className="w-5 h-5 shrink-0 mt-0.5" />
          <span>Convide amigos e familiares para ajudar a pagar <span className="font-bold text-white">{meta.referente}</span>. Juntos chegamos lá mais rápido.</span>
        </p>
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-2">
          <button
            type="button"
            data-testid="share-whatsapp-button"
            onClick={shareWhatsapp}
            className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-xl bg-[#25D366] hover:bg-[#1fbe5a] active:scale-[0.98] text-white font-bold text-base sm:text-lg transition-[background-color,transform]"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.4-1.5-.9-.8-1.5-1.8-1.6-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.2-1.4c1.4.8 3.1 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3.1.8.8-3-.2-.3C4 15 3.7 13.5 3.7 12c0-4.6 3.7-8.3 8.3-8.3s8.3 3.7 8.3 8.3-3.7 8.2-8.3 8.2z"/></svg>
            COMPARTILHAR NO WHATSAPP
          </button>
          <div className="flex gap-2">
            <button type="button" data-testid="share-copy-button" onClick={copiar} title="Copiar convite" className="flex-1 sm:flex-none inline-flex items-center justify-center gap-1.5 px-4 py-3.5 rounded-xl bg-white/10 hover:bg-white/20 border border-white/20 font-semibold text-sm transition-colors">
              <Copy className="w-4 h-4" /> Copiar
            </button>
            <button type="button" data-testid="share-native-button" onClick={nativo} title="Mais opções" className="flex-1 sm:flex-none inline-flex items-center justify-center gap-1.5 px-4 py-3.5 rounded-xl bg-white/10 hover:bg-white/20 border border-white/20 font-semibold text-sm transition-colors">
              <Share2 className="w-4 h-4" /> Mais
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
